import * as ng from 'angular';
import { EnvRibbonComponent } from './env-ribbon.component';
import './env-ribbon.scss';



export const EnvRibbonModule : string = ng
  .module('env-ribbon', [
  ])
  .component('envRibbon', EnvRibbonComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/env-ribbon/env-ribbon.module.ts